<sd-modal>
  <div class="modal-header">
    <h3>Кто будет покупать?</h3>
  </div>

  <div class="modal-body">
    <button *ngIf="user$ | async as user" type="unset" class="item" (click)="resetSelectedCompany()">
      {{ user.name }}
    </button>
    <button
      type="unset"
      class="item"
      *ngFor="let company of userCompanies$ | async"
      (click)="selectCompany(company.uid)"
    >
      {{ company.name }}
    </button>
  </div>
  <div class="modal-footer">
    <sd-add-company-button action="redirect" size="s" (click)="closeModal()"></sd-add-company-button>
  </div>
</sd-modal>
